module.exports = __webpack_public_path__ + "static/media/cloud5@2x.2044367b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/AttractLoopView/cloud5@2x.png
// module id = 871
// module chunks = 0